import { faTrashCan } from "@fortawesome/pro-solid-svg-icons";
import type { BatchAction } from "@components/CatalogIndex";

// Payment credits have no archive/restore — a single permanent Delete action.
export const buildPaymentCreditBatchActions = (
  onDelete: () => void
): BatchAction[] => [
  {
    icon: faTrashCan,
    label: "Delete",
    onClick: onDelete,
    variant: "danger",
  },
];
